<template>
  <section
    v-if="isReady && videoUrl !== null"
  >
    <iframe
      v-if="embedSrc !== null"
      :src="embedSrc"
      title="Property Video"
    />
    <video
      v-else
      class="w-full"
      controls
      :src="videoUrl"
    />
  </section>
</template>

<script>
import { EmbedUrl } from 'mytribus-commons';
import { extract, hasProvider } from '@extractus/oembed-extractor';

import getPropertyVideoUrl from '../helpers/getPropertyVideoUrl';

export default {
  name: 'PropertyVideo',

  display({ isBranded, property }) {
    return isBranded && getPropertyVideoUrl(property) !== null;
  },

  props: {
    property: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      embedSrc: null,
      isReady: true,
    };
  },

  computed: {
    /** @type {string|null} */
    videoUrl() {
      return getPropertyVideoUrl(this.property);
    },
  },

  async created() {
    if (this.videoUrl === null) {
      return;
    }

    if (!hasProvider(this.videoUrl)) {
      const embedUrl = new EmbedUrl(this.videoUrl);

      if (embedUrl.hasMatch()) {
        this.embedSrc = embedUrl.embedUrl;
      }

      return;
    }

    try {
      const oembed = await extract(this.videoUrl);

      if (oembed.html !== undefined) {
        const parser = new DOMParser();
        const iframeMarkup = parser.parseFromString(oembed.html, 'text/html');
        const [iframe] = iframeMarkup.getElementsByTagName('iframe');

        this.embedSrc = iframe.src;
      }
    } catch (e) {
      //
    } finally {
      this.isReady = true;
    }
  },
};
</script>

<style scoped>
iframe,
video {
  aspect-ratio: 16/9;
  max-height: 750px;
  width: 100%;
  background: #000;
}
</style>
